import { z } from 'zod';
import iterationCohortSchema from 'schemas/IterationCohort.schema.ts';
import iterationRuleSchema from 'schemas/IterationRule.schema.ts';
import { COMMS_TYPES, ITERATION_TYPES } from 'schemas/enums/iterations.ts';
import { validateDate } from 'utils/validatorUtils.ts';
import { validStringCharacterMessage, validStringCharacters } from 'schemas/shared-validators/regex.ts';
import { CohortMetadata } from 'schemas/metadata/cohorts.ts';

const restrictedString = z.string().regex(validStringCharacters, validStringCharacterMessage);

export const iterationSchema = (cohortData: CohortMetadata[]) => {
  const cohortSchema = iterationCohortSchema(cohortData);

  return z.object({
    ID: z.string().optional(),
    DefaultCommsRouting: z.string().optional(),
    Version: z.number().optional(),
    Name: restrictedString.min(1, { message: 'Iteration Name is required' }).optional(),
    IterationDate: z.string().superRefine(validateDate).optional(),
    IterationNumber: z.number().optional(),
    CommsType: z.enum(COMMS_TYPES).optional(),
    ApprovalMinimum: z.number({ message: 'Minimum approval number is required' }).optional(),
    ApprovalMaximum: z.number({ message: 'Maximum approval number is required' }).optional(),
    Type: z.enum(ITERATION_TYPES).optional(),
    IterationCohorts: z.array(cohortSchema).optional(),
    IterationRules: z.array(iterationRuleSchema).optional(),
  });
};

export const iterationDetailsFormSchema = (cohortData: CohortMetadata[]) => {
  const schema = iterationSchema(cohortData);

  return schema.pick({
    Name: true,
    IterationDate: true,
    CommsType: true,
    ApprovalMinimum: true,
    ApprovalMaximum: true,
    Type: true,
    IterationCohorts: true,
    IterationRules: true,
  }).required();
};

export type Iteration = z.infer<ReturnType<typeof iterationSchema>>;
export type IterationDetailsFormValues = z.infer<ReturnType<typeof iterationDetailsFormSchema>>;
export type IterationRule = z.infer<typeof iterationRuleSchema>;

export default iterationSchema;
